import React, { Component } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";

import SegmentMessage from "../forms/messages/SegmentMessage.jsx";

import { MARKING_MESSAGE_STATES } from "../../utils/marking.js";

import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class MarkingMessage extends Component {
  static propTypes = {
    type: PropTypes.string.isRequired,
    message: PropTypes.string,
    copy: PropTypes.func.isRequired
  };

  static RESOURCE = "resource";
  static PROJECT = "project";
  static IMAGE = "image";
  static USER = "user";

  // -- RENDER -- //

  getTypeState() {
    const { message } = this.props;

    switch (message) {
      case MARKING_MESSAGE_STATES.SAVING:
      case MARKING_MESSAGE_STATES.CREATING:
      case MARKING_MESSAGE_STATES.CREATED:
        return {
          info: true,
          negative: false,
          warning: false,
          icon: "cogs"
        };
      case MARKING_MESSAGE_STATES.LOCKED:
        return {
          info: true,
          negative: false,
          warning: false,
          icon: "cogs"
        };
      case MARKING_MESSAGE_STATES.ARCHIVED:
        return {
          info: false,
          negative: true,
          warning: false,
          icon: "archive"
        };
      case MARKING_MESSAGE_STATES.DELETED:
        return {
          info: false,
          negative: true,
          warning: false,
          icon: "trash alternate"
        };
      case MARKING_MESSAGE_STATES.ERROR:
        return {
          info: false,
          negative: true,
          warning: false,
          icon: "exclamation circle"
        };
      default:
        return {
          info: false,
          negative: false,
          warning: false,
          icon: "circle notched"
        };
    }
  }

  render = () => {
    const { type, message, copy } = this.props;

    // bail early if no message is provided
    if (!message) return null;

    const typeState = this.getTypeState();

    return (
      <div>
        <SegmentMessage
          title={copy(`${type}.${message}.title`)}
          message={copy(`${type}.${message}.body`)}
          info={typeState.info}
          negative={typeState.negative}
          warning={typeState.warning}
          icon={typeState.icon}
          className="clear-both"
        />
      </div>
    );
  };
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(MarkingMessage);
